<div class="content-block">

    <!-- Content Header (Page header) -->
    
    <div class="content-header">
       <div class="container-fluid">
         <div class="row">
           <div class="col-sm-6">
             <h1 class="m-0 text-dark"><b>Magazzino</b> </h1>
           </div><!-- /.col -->
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
               <li class="breadcrumb-item">Magazzino</li>
               <li class="breadcrumb-item active">Giacenze</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
     </div>
</div>

<div class="content-block">


  <section class="col-lg-12 ">

     <div class="card primary">
       <div class="card-header">
         <h3 class="card-title">
           <i class="fa fa-chart-pie mr-1"></i>
           Giacenze articoli
          </h3>
         
       </div><!-- /.card-header -->
       <div class="card-body">
        
    <app-grid-articoli [bEditable]="false"></app-grid-articoli>


       </div><!-- /.card-body -->
     </div>
     <!-- /.card -->

   </section>



</div>
